<template>
  <div>
    <v-dialog
      v-model="showDialog"
      width="400"
      persistent
    >
      <v-card
        v-if="order"
        style="position: relative;"
      >
        <v-card-title class="subheading py-0">
          <v-layout align-center>
            <div class="title">
              <span v-if="order.jyorders">支付 {{ order.jyorders.length }} 笔訂單</span>
              <span v-else>支付訂單 {{ order.id }}</span>
            </div>
            <v-spacer />
            <v-btn
              icon
              @click="showDialog = false"
            >
              <v-icon small>
                close
              </v-icon>
            </v-btn>
          </v-layout>
        </v-card-title>

        <v-card-text>
          <div class="text-xs-center pb-4">
            <div class="mb-3 headline">
              支付金額
            </div>
            <span class="headline">NT$</span> <b class="display-3">{{ order.amount | toTwb }}</b>
          </div>
          <slot name="feeDetail" />
          <v-divider />
          <v-layout
            align-start
            class="mx-0 my-4"
          >
            <span class="pa-0 subheading pt-2">
              支付方式
            </span>
            <div class="text-xs-left ml-3 pt-2">
              <div>
                <span
                  v-if="isLack"
                  class="orange--text subheading"
                >{{ coinName }}餘額不足</span>
                <span v-else>{{ coinName }}</span>
                <span class="body-2">
                  (剩餘 {{ pfBalance }})
                </span>
              </div>
              <div
                v-if="frozenAmount>0"
                class="mt-2"
              >
                有<a
                  class="blue--text mx-1"
                  @click="$refs.LedgerfrozenDialog.open(coinType)"
                ><u>{{ frozenAmount }}</u></a>不可用
              </div>
            </div>
            <v-spacer />
            <!-- <v-btn
              v-if="isLack"
              flat
              large
              color="info"
              class="ma-0 ml-2 pa-0"
              style="min-width: auto;"
              @click="toWalletRecharge"
            >
              儲值並支付
            </v-btn> -->
            <v-btn
              v-if="isLack"
              small
              color="info"
              @click="toWalletRecharge"
            >
              儲值並支付
            </v-btn>
          </v-layout>
          <PwdInput
            v-if="!isLack"
            v-model="payPwd"
            :disabled="loading || !!isLack"
            large
          />
          <v-layout
            v-if="!isLack"
            class="mt-4 mx-0"
          >
            <div>* 請輸入6位錢包密碼</div>
            <v-spacer />
          </v-layout>
          <div class="red--text mt-2">
            {{ errorMsg }}
          </div>
        </v-card-text>

        <div
          v-if="loading"
          class="white--text payLoading"
          style="font-size: 30px;"
        >
          正在支付
          <v-progress-circular
            indeterminate
            color="white"
            class="ml-4"
          />
        </div>
      </v-card>
      <v-card v-else>
        <div
          class="text-xs-center py-4 title "
        >
          <v-progress-circular
            indeterminate
            small
            class="ml-4"
          />
        </div>
      </v-card>
    </v-dialog>

    <LedgerfrozenDialog ref="LedgerfrozenDialog" />
  </div>
</template>
<script>
import eventBus, { eventType } from '@g/utils/eventBus'
import PwdInput from '@/components/PwdInput'
import LedgerfrozenDialog from '@/views/_merchant/wallet/components/LedgerfrozenDialog.vue'

export default {
  components: {
    PwdInput,
    LedgerfrozenDialog,
  },
  props: {
    // 切换 dialog 的显示
    propsShow: {
      type: Boolean
    },
    order: {
      type: Object
    },
    propPay: Function,
    // M 币(代购)支付，巧巧郎项目内用于 M 前缀订单
    mcoin: {
      type: Boolean,
      default: false
    },
    // 本单需额外冻结的税金保證金，计入余额是否充足的判断
    freezeAmount: {
      type: [Number, String],
      default: 0
    },
  },
  data () {
    return {
      showDialog: this.propsShow,
      loading: false,
      profileDetail: { pfBalance: 0 },
      payPwd: '',
      errorMsg: '',
    }
  },
  computed: {
    isMgb () {
      return ['mgb-pc', 'mgb-h5'].includes(this.$store.state.project)
    },
    // 是否用 M 币支付：买即可项目，或巧巧郎项目内的 M 币(代购)订单
    isMcoinPay () {
      return this.isMgb || this.mcoin
    },
    coinName () {
      return this.isMcoinPay ? 'M幣' : 'T幣'
    },
    coinType () {
      return this.isMcoinPay ? 'M' : 'T'
    },
    // T币可用余额（钱包真实可用，用于冻结税金的跨币种校验）
    tcoinAvail () {
      return this.$calc.sub(this.profileDetail.pfBalance || 0, this.profileDetail.frozenAmount || 0)
    },
    // M币可用余额
    mcoinBalance () {
      return this.profileDetail.creditdgAvailBal || 0
    },
    isLack () { // 余额不足（含本单需冻结的税金保證金）
      // 当前支付币种不够支付金额
      if (this.pfBalance < (this.order?.amount || 0)) return true
      // 还需冻结税金：冻结优先T币不足M币，故两币合计须够「支付金额 + 冻结税金」
      if (this.freezeAmount > 0) {
        const need = this.$calc.add(this.order?.amount || 0, this.freezeAmount)
        if (this.$calc.add(this.tcoinAvail, this.mcoinBalance) < need) return true
      }
      return false
    },
    noFrozen () {
      if (this.isMcoinPay) return 0
      if (this.order?.jyOid && this.profileDetail.ledgerfrozen) {
        const f = this.profileDetail.ledgerfrozen.find(item => item.frzSource === this.order?.jyOid)
        if (f) {
          return this.$calc.sub(f.frzAmount, f.lgAmount || 0)
        }
      }
      return 0
    },
    frozenAmount () {
      if (this.isMcoinPay) return this.profileDetail.creditdgFrozenAmount || 0
      return this.$calc.sub(this.profileDetail.frozenAmount, this.noFrozen)
    },
    pfBalance () {
      if (this.isMcoinPay) return this.mcoinBalance
      return this.$calc.sub(this.profileDetail.pfBalance, this.frozenAmount)
    },
  },
  watch: {
    propsShow (newValue) {
      this.showDialog = newValue
      if (this.showDialog) {
        this.getWalletProfile()
      }
    },
    showDialog (newValue) {
      // 提交 dialog 状态到父组件
      this.$emit('update:propsShow', newValue)
    },
    payPwd (newValue) {
      this.payPwd = this.payPwd.replace(/[^0-9]/g, '').substring(0, 6)
      if (!this.isLack && !this.loading && this.payPwd.length === 6) {
        this.pay()
      }
    }
  },
  mounted () {
    if (this.showDialog) {
      this.getWalletProfile()
    }
    this.timer = setInterval(() => {
      if (this.showDialog) {
        this.getWalletProfile()
      }
    }, 1000 * 30)
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  methods: {
    async getWalletProfile () {
      // const res = await this.$store.dispatch('wallet/ledger/index', {
      //   pageSize: 1
      // })
      // if (res.data.list.length) {
      //   this.profileDetail.pfBalance = Number(res.data.list[0].lgBalance)
      // } else {
      await this.$store.dispatch('wallet/profile/view')
      this.profileDetail = this.$store.state.wallet.profile.viewData
      // }
    },
    async pay () {
      if (this.loading) return
      try {
        this.loading = true
        if (!this.payPwd) {
          this.$snackbar('請輸入錢包密碼', { color: 'error' })
          return
        }
        const res = await this.propPay(this.payPwd)
        if (!res.data.error) {
          this.$snackbar('支付成功', { color: 'success' })
          this.$emit('success')
          this.showDialog = false
          eventBus.$emit(eventType.BalanceChange)
        } else {
          this.payPwd = ''
          if (res.data.error === 'PayPwdErrsLimit') {
            this.errorMsg = res.data.message || '密碼錯誤'
          } else if (res.data.error === 'LedgerBalanceLess') {
            this.errorMsg = `${this.coinName}餘額不足`
          } else {
            this.errorMsg = res.data.message || res.data.error
          }
          this.getWalletProfile()
        }
      } finally {
        this.payPwd = ''
        this.loading = false
      }
    },
    toWalletRecharge () {
      this.showDialog = false
      this.$emit('toWalletRecharge')
      if (this.isMcoinPay) {
        this.$router.push({ name: 'WalletRecharge', query: { porBiz: 'DG' } })
        return
      }
      if (this.profileDetail.hasPayPwd === 0) {
        this.$snackbar('請先設置錢包密碼', { color: 'error' })
        eventBus.$emit(eventType.OpenSetPayPwdDialog)
        return
      }
      this.$router.push({ name: 'WalletRecharge' })
    },
  }
}
</script>

<style lang="postcss" scoped>
.pwd-input {
  display: flex;
  position: relative;
  justify-content: space-between;
  & > div {
    flex: none;
    width: 50px;
    height: 50px;
    border: 1px solid #cecece;
    font-size: 25px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  & > input {
    position: absolute;
    width: 100%;
    height: 100%;
    outline: none;
    opacity: 0;
    &:focus ~ div {
      &.active {
        border-color: rgb(82 168 236 / 60%);
        &:before {
          content: "|";
          font-weight: bold;
          animation: buling 1s infinite;
        }
        box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%),
          0 0 8px rgb(82 168 236 / 60%);
      }
    }
  }
}
@keyframes buling {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 1;
  }
  51% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}

.payLoading {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0,0,0,0.7);
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
